// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".distribution-thumbnail[data-v-5e4b6d7d]{position:relative;width:100%}.distribution-thumbnail[data-v-5e4b6d7d]:before{display:block;padding-top:132.63158%;content:\"\"}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
